export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const EXTERNAL_INSP_BASE_URL =
  process.env.REACT_APP_EXTERNAL_INSP_BASE_URL; 
